/*
 * サブシステム名：燃費管理
 * 機能名：給油実績一覧登録
 */
import DdCustomButton from '@/components/DdCustomButton'
import DdDateBox from '@/components/DdDateBox'
import DdFileInput from '@/components/DdFileInput'
import DdTransparentButton from '@/components/DdTransparentButton'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'
import message from '@/ddv2.library/messages'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import dolly from '@/rahmen/utils/dolly'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
const DdTimeBox = () => import('@/components/DdTimeBox')

export default {
  name: 'NenryoListEdit',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    itemsPerPage: 100,
    page: 1,
    isTorikomiHide: false,
    isConditionHide: false,
    isTemplateDownloader: false,
    isExcelDownloader: false,

    rows: [],
    conditions: {},
    selected: [],
    target: [],
    modeKengen: 0,
    pageCount: 0,
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    // 画面表示制御
    torikomiConditonsRequired: true,
    tableRowRequired: true,
    headerMode: 1
  }),
  components: {
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdDateBox,
    DdDefaultButton,
    DdDropDown,
    DdEditDialog,
    DdFileInput,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTransparentButton,
    DdTimeBox
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      sharyoList: 'DDMasters/vwCMstSharyo',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem, index) => {
        elem.rowNo = index + 1
        elem.hasseiYmd = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiHms = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.sharyoShozokuEigyoshoDisp = elem.sharyoShozokuEigyoshoCd ? elem.sharyoShozokuEigyoshoCd + ' : ' + elem.sharyoShozokuEigyoshoNm : ''
        elem.suryo = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTanka = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.keihiKingaku = elem.keihiKingaku ? filter.numericFormatter(elem.keihiKingaku) : ''
        elem.odoMater = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
        elem.memo = elem.editFlg === true ? '変更中' : '　　　'
        elem.hasseiYmdDisp = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiHmsDisp = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.torikomiShiiresakiDisp = elem.torihikisakiCd ? elem.torihikisakiCd + ' : ' + elem.torihikisakiNm : elem.torikomiShiiresakiCd
        elem.torikomiSharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.mstSharyoNm : elem.torikomiSharyoNo
        elem.suryoDisp = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTankaDisp = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.odoMaterDisp = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
        elem.sagyoJisshiBashoDisp = elem.sagyoJisshiBasho ? elem.sagyoJisshiBasho : ''
        elem.kessaiCardNumberDisp = elem.kessaiCardNumber ? elem.kessaiCardNumber : ''
        return elem
      })
    },
    dispHeader () {
      const self = this
      let header = []
      if (self.headerMode === 1) {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '編集', value: 'editAction', align: 'center', sortable: false, width: '80px' },
          { text: '反映', value: 'actions', align: 'center', sortable: false, width: '80px' },
          { text: '変更状況', value: 'memo', align: 'center', width: '80px' },
          { text: '発生年月日', value: 'hasseiYmd', width: '175px' },
          { text: '発生時刻', value: 'hasseiHms', width: '125px' },
          { text: '車両番号/自動車表示名', value: 'mstSharyoId', width: '270px' },
          { text: '燃料区分', value: 'nenryoShuruiKbn', width: '155px' },
          { text: '数量', value: 'suryo', align: 'end' },
          { text: '単価', value: 'keihiTanka', align: 'end' },
          { text: '金額', value: 'keihiKingaku', align: 'end' },
          { text: '給油時オド', value: 'odoMater' },
          { text: '仕入先', value: 'torihikisakiId', width: '270px' },
          { text: '営業所', value: 'sharyoShozokuEigyoshoDisp', width: '270px' },
          { text: '車種', value: 'shashuSbtNm', width: '85px' },
          { text: '給油SS', value: 'sagyoJisshiBasho', width: '300px' },
          { text: 'カードNo', value: 'kessaiCardNumber', width: '200px' },
          { text: '車両経費No', value: 'sharyoKeihiNo' }
        ]
      } else {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '行', value: 'rowNo', align: 'center', sortable: false, width: '80px' },
          { text: '発生年月日', value: 'hasseiYmdDisp', width: '175px' },
          { text: '発生時刻', value: 'hasseiHmsDisp', width: '125px' },
          { text: '仕入先', value: 'torikomiShiiresakiDisp', width: '270px' },
          { text: '営業所', value: 'sharyoShozokuEigyoshoDisp', width: '270px' },
          { text: '車種', value: 'shashuSbtNm', width: '85px' },
          { text: '車両番号/自動車表示名', value: 'torikomiSharyoDisp', width: '270px' },
          { text: '燃料区分', value: 'nenryoShuruiKbnNm', width: '155px' },
          { text: 'エラーメッセージ', value: 'errMessage' },
          { text: '数量', value: 'suryoDisp', align: 'end' },
          { text: '単価', value: 'keihiTankaDisp', align: 'end' },
          { text: '金額', value: 'keihiKingaku', align: 'end' },
          { text: '給油時オド', value: 'odoMaterDisp', align: 'end' },
          { text: '給油SS', value: 'sagyoJisshiBashoDisp', width: '300px' },
          { text: 'カードNo', value: 'kessaiCardNumberDisp', width: '200px' },
          { text: '車両経費No', value: 'sharyoKeihiNo' }
        ]
      }
      return header
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 取引先フィルター
    filteredMstTorihikisaki () {
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    },
    // 仕入先フィルター
    filteredShiiresakiList () {
      const target = filter.dateFormatter(new Date())
      return this.filteredMstTorihikisaki.filter((t) => {
        return t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target && t.shiiresakiFlg === true
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 給油実績データ取込レイアウト区分フィルター
    filteredNenryoTorikomiLayoutKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF108')
    },
    // 車種フィルター
    filteredShashuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 燃料区分フィルター
    filteredFuelKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF053')
    },
    // Templateボタン活性条件
    isTemplateButtonDisabled () {
      return this.isTemplateDownloader
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0 || this.isExcelDownloader
    },
    // 保存ボタン活性条件
    isMultiSaveButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      const saveTagetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTagetRow.length < 1) {
        return true
      }
      return false
    },
    multiSaveButtonDisp () {
      if (this.modeKengen === 0 || this.headerMode === 2) {
        return false
      }
      return true
    },
    // 削除ボタン活性条件
    isMultiDeleteButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      if (this.rows.length > 0 && this.selected.length > 0) {
        return false
      }
      return true
    },
    multiDeleteButtonDisp () {
      if (this.modeKengen !== 2 || this.headerMode === 2) {
        return false
      }
      return true
    },
    newAddButtonDisp () {
      if (this.modeKengen === 0 || this.headerMode === 2) {
        return false
      }
      return true
    },
    isEditReadonly () {
      if (this.modeKengen === 0 || this.headerMode === 2) {
        return true
      }
      return false
    },
    isReadOnly () {
      if (this.modeKengen === 0) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'vwcmstsharyo', 'msyskubun', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.$nextTick(function () {
        this.searchAction()
      })
    },
    searchAction: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCD2fued0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.headerMode = 1
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
          const res = data.payload
          res.map((elem) => {
            elem.editFlg = false
            elem.editMode = false
            return elem
          })
          self.rows = res
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
              self.cloneRows = dolly.clone(self.getCloneTargetMethod())
            })
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      // 発生年月日不整合チェック
      if (this.conditions.hasseiYmdStartString && this.conditions.hasseiYmdEndString) {
        const msg1 = validators.compareDate(this.conditions.hasseiYmdStartString, this.conditions.hasseiYmdEndString)
        if (msg1 !== undefined) {
          this.$refs.hasseiYmdStartString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.hasseiYmdEndString[this.Ctrls.SET_INVALID_METHOD](msg1)
          modals.showToastMessage('COME0014', null, 500, null, 'error')
          this.torikomiConditonsRequired = true
          this.tableRowRequired = true
          return false
        }
      }
      return true
    },
    onClearButtonClick: function (e) {
      if (this.headerMode === 1) {
        this.onSearchConditonsClearButtonClick()
      } else {
        this.onFileInputClearButtonClick()
      }
    },
    onFileInputClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear(1)
    },
    onSearchConditonsClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear(2)
    },
    // p = 1:ファイル取込の設定条件をクリアする
    // p = 2:検索条件をクリアする
    // p = 未指定:すべてクリア
    clear: function (p) {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables(p)
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onFileImportButtonClick: function (e) {
      let errorCount = 0
      if ((['', null, undefined]).includes(this.conditions.importShiiresakiId)) {
        this.$refs.importShiiresakiId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if ((['', null, undefined]).includes(this.conditions.importFileKbn)) {
        this.$refs.importFileKbn[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if ((['', null, undefined]).includes(this.conditions.uploadFileData)) {
        this.$refs.file[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        errorCount++
      }
      if (errorCount > 0) { return }
      const importConditions = {
        importShiiresakiId: this.conditions.importShiiresakiId,
        importFileKbn: this.conditions.importFileKbn,
        uploadFileName: this.conditions.uploadFileName,
        uploadFileData: this.conditions.uploadFileData
      }
      this.Effects.loadStart()
      this.HttpClient.post('/api/v1/vwCD2fued0010/NenryoFileImport', importConditions)
        .then((data) => {
          if (data.isValid) {
            console.log('retdata', data)
            this.headerMode = 2
            modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'info')
            this.rows = data.payload.resultList
            this.recordCount = data.payload.recordCount
            this.successCount = data.payload.successCount
            this.errorCount = data.payload.errorCount
            this.Effects.loadComplete()
            // this.transition(0, { id: data.payload, edit: 1 })
          } else {
            modals.showToastMessage(data.summaryMessage.messageCd, null, 500, null, 'error')
            this.Effects.loadComplete()
          }
        }).catch((e) => {
          console.log('error', e)
          modals.showToast(e.message, null, 500, null, 'error')
          this.Effects.loadComplete()
        })
    },
    onTorikomiTemplateButtonClick: function (e) {
      this.isTemplateDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0010/NenryoTorikomiTemplateOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('templateDownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '給油実績取込テンプレート_' + ts + '.xlsx'
          elem.click()
          modals.showToastMessage('COMI0005', null, 500, null, 'info')
          this.isTemplateDownloader = false
        })
    },
    onExcelButtonClick: function (e) {
      this.isExcelDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0010/excelOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('exceldownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '給油実績一覧_' + ts + '.xlsx'
          elem.click()
          modals.showToastMessage('COMI0005', null, 500, null, 'info')
          this.isExcelDownloader = false
        })
    },
    storeFileInfo: function (p) {
      console.log('file selected', p)
      if (p === undefined || p === null) {
        this.conditions.uploadFileName = ''
        this.conditions.uploadFileData = ''
        return
      }
      this.clearInvalidMessage(this.$refs)
      this.Effects.loadStart()
      this.conditions.uploadFileName = p.name

      const fr = new FileReader()
      fr.readAsDataURL(p)
      fr.addEventListener('load', () => {
        this.conditions.uploadFileData = fr.result
      })
      this.Effects.loadComplete()
      console.log('file selected e')
    },
    onCancel: function (item) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      const index = this.rows.indexOf(item)
      this.getData(item.id, index)
    },
    /**
   * 更新後の再取得 ※対象行のデータとClone情報を差し替える
   * @param {} recId
   * @param {*} rowIndex
   * @returns
   */
    getData: function (recId, rowIndex) {
      // サマリメッセージ初期化
      // this.clearSummaryMessage()
      if (recId > 0) {
        return new Promise((resolve) => {
          this.HttpClient
            .get(`/api/v1/VwCD2fued0010/find?id=${recId}`)
            .then((data) => {
              const rec = data.payload
              // 取得データを差し替え
              rec.editFlg = false
              rec.editMode = false
              rec.memo = ''
              rec.hasseiYmd = rec.hasseiYmd ? filter.dateFormatter(rec.hasseiYmd) : ''
              rec.hasseiHms = rec.hasseiHms ? (rec.hasseiHms).slice(0, 5) : ''
              rec.suryo = rec.suryo ? filter.numericFormatter(rec.suryo) : ''
              rec.keihiTanka = rec.keihiTanka ? filter.numericFormatter(rec.keihiTanka) : ''
              rec.keihiKingaku = rec.keihiKingaku ? filter.numericFormatter(rec.keihiKingaku) : ''
              rec.odoMater = rec.odoMater ? filter.numericFormatter(rec.odoMater) : ''
              Object.assign(this.rows[rowIndex], rec)
              // CloneData更新
              this.cloneRows = dolly.clone(this.getCloneTargetMethod())
              // 画面への再描写 ※強制発火用にspliceを実行
              this.rows.splice()
              resolve()
            })
        })
      } else {
        const newrow = {
          id: 0,
          editFlg: false,
          editMode: true,
          rowNo: this.rows.length + 1,
          memo: '　　　',
          hasseiYmd: '',
          hasseiHms: '',
          torihikisakiId: '',
          mstSharyoId: '',
          nenryoShuruiKbn: '',
          suryo: '',
          keihiTanka: '',
          keihiKingaku: '',
          odoMater: ''
        }
        Object.assign(this.rows[rowIndex], newrow)
        // CloneData更新
        this.cloneRows = dolly.clone(this.getCloneTargetMethod())
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    onSave: function (item) {
      const saveTagetRow = Object.assign({}, item)
      if ((['', null, undefined]).includes(saveTagetRow.hasseiYmd)) {
        modals.showToastMessage('COME0001', null, 500, null, 'error')
        return
      }
      saveTagetRow.suryo = saveTagetRow.suryo ? this.getNullValue(saveTagetRow.suryo) : null
      saveTagetRow.keihiTanka = saveTagetRow.keihiTanka ? this.getNullValue(saveTagetRow.keihiTanka) : null
      saveTagetRow.keihiKingaku = saveTagetRow.keihiKingaku ? this.getNullValue(saveTagetRow.keihiKingaku) : null
      saveTagetRow.odoMater = saveTagetRow.odoMater ? this.getNullValue(saveTagetRow.odoMater) : null

      this.target = [saveTagetRow]
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.$nextTick(function () {
        this.saveAction(saveTagetRow)
      })
    },
    onMultiSaveButtonClick: function (e) {
      const saveTagetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTagetRow.length < 1) { return }
      const errorRow = saveTagetRow.filter(function (elem) {
        return (['', null, undefined]).includes(elem.hasseiYmd)
      })
      if (errorRow.length > 0) {
        modals.showToastMessage('COME0001', null, 500, null, 'error')
        return
      }
      saveTagetRow.map((elem) => {
        elem.suryo = elem.suryo ? this.getNullValue(elem.suryo) : null
        elem.keihiTanka = elem.keihiTanka ? this.getNullValue(elem.keihiTanka) : null
        elem.keihiKingaku = elem.keihiKingaku ? this.getNullValue(elem.keihiKingaku) : null
        elem.odoMater = elem.odoMater ? this.getNullValue(elem.odoMater) : null
        return elem
      })
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.target = saveTagetRow
      this.$nextTick(function () {
        this.saveAction(saveTagetRow)
      })
    },
    saveAction: function (p) {
      this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/VwCD2fued0010/RegisterMulti', self.target)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.selected = []
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            const dataList = data.payload.item1
            dataList.map((elem) => {
              elem.editFlg = false
              elem.editMode = false
              elem.memo = ''
              elem.hasseiYmd = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
              elem.hasseiHms = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
              elem.suryo = elem.suryo ? filter.numericFormatter(elem.suryo) : ''
              elem.keihiTanka = elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
              elem.keihiKingaku = elem.keihiKingaku ? filter.numericFormatter(elem.keihiKingaku) : ''
              elem.odoMater = elem.odoMater ? filter.numericFormatter(elem.odoMater) : ''
              return elem
            })
            const newDataRowList = self.target.filter(function (elem) {
              return elem.id < 1
            })
            newDataRowList.forEach(elem => {
              const index = this.rows.indexOf(elem)
              self.rows.splice(index, 1)
            })

            dataList.forEach(elem => {
              const tagetRow = self.rows.find(n => n.id === elem.id)
              if (tagetRow) {
                const index = this.rows.indexOf(tagetRow)
                // 取得データを差し替え
                Object.assign(this.rows[index], elem)
              } else {
                if (self.rows.length > 0) {
                  self.rows.push(elem)
                } else {
                  self.rows = [elem]
                }
              }
            })
            // CloneData更新
            self.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            self.rows.splice()
            self.Effects.loadComplete()
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    onMultiDeleteButtonClick: function (e) {
      const deleteTagetRow = this.selected.map((elem) => {
        elem.suryo = elem.suryo ? this.getNullValue(elem.suryo) : null
        elem.keihiTanka = elem.keihiTanka ? this.getNullValue(elem.keihiTanka) : null
        elem.keihiKingaku = elem.keihiKingaku ? this.getNullValue(elem.keihiKingaku) : null
        elem.odoMater = elem.odoMater ? this.getNullValue(elem.odoMater) : null
        return elem
      })

      this.target = deleteTagetRow
      this.torikomiConditonsRequired = false
      this.tableRowRequired = false
      this.$nextTick(function () {
        this.deleteAction(deleteTagetRow)
      })
    },
    deleteAction: function (deleteTagetRow) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2fued0010/DeleteMulti', self.target).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            self.selected.forEach(elem => {
              const index = self.rows.indexOf(elem)
              // 選択行を削除
              self.rows.splice(index, 1)
            })
            // CloneData更新
            self.cloneRows = dolly.clone(self.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            self.rows.splice()
            self.selected = []
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            resolve()
          })
        },
        failureResponsePromise: () => {
          return new Promise(resolve => {
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            resolve()
          })
        },
        onCancelClickMethod: function () {
          return new Promise(resolve => {
            self.torikomiConditonsRequired = true
            self.tableRowRequired = true
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onNewRowButtonClick: function () {
      const newrow = {
        id: 0,
        editFlg: false,
        editMode: true,
        rowNo: this.rows.length + 1,
        memo: '　　　',
        hasseiYmd: '',
        hasseiHms: '',
        torihikisakiId: '',
        mstSharyoId: '',
        nenryoShuruiKbn: '',
        suryo: '',
        keihiTanka: '',
        keihiKingaku: '',
        odoMater: ''
      }
      this.rows.push(newrow)
      // CloneData更新
      this.cloneRows = dolly.clone(this.getCloneTargetMethod())
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    onEditMode: function (row) {
      console.log(row)
      const index = this.rows.indexOf(row)
      const rec = Object.assign({}, row)
      rec.editMode = !rec.editMode
      this.onEditClose(rec, index)
    },
    onEditCloseHasseiYmd: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      if (e.length === 10) {
        rec.hasseiYmd = e
      }
      this.onEditClose(rec, index)
    },
    onEditCloseHasseiHms: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      rec.hasseiHms = e
      this.onEditClose(rec, index)
    },
    onEditCloseShiiresaki: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      const shiiresakiInfo = indexeddb.getRecord(this.torihikisakiList, e)
      rec.torihikisakiId = e
      rec.torihikisakiCd = shiiresakiInfo ? shiiresakiInfo.torihikisakiCd : ''
      rec.torihikisakiNm = shiiresakiInfo ? shiiresakiInfo.torihikisakiNm : ''
      this.onEditClose(rec, index)
    },

    onEditCloseMstSharyo: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      rec.mstSharyoId = e
      const mstSharyoInfo = indexeddb.getRecord(this.sharyoList, e)
      rec.sharyoShozokuEigyoshoCd = mstSharyoInfo ? mstSharyoInfo.eigyoshoCd : ''
      rec.sharyoShozokuEigyoshoNm = mstSharyoInfo ? mstSharyoInfo.eigyoshoNm : ''
      rec.shashuSbtNm = mstSharyoInfo ? mstSharyoInfo.shashuSbtNm : ''
      rec.sharyoNo = mstSharyoInfo ? mstSharyoInfo.sharyoNo : ''
      rec.mstSharyoNm = mstSharyoInfo ? mstSharyoInfo.mstSharyoNm : ''
      rec.nenryoShuruiKbn = mstSharyoInfo && !rec.nenryoShuruiKbn ? mstSharyoInfo.fuelKbn : rec.nenryoShuruiKbn
      this.onEditClose(rec, index)
    },
    onEditCloseNenryoShuruiKbn: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      const neryoKbnRecord = indexeddb.getKubun(this.currentKaishaCode, this.kubunList, 'SFF053', e)
      rec.nenryoShuruiKbn = e
      rec.nenryoShuruiKbnNm = neryoKbnRecord ? neryoKbnRecord.codeNm : ''
      this.onEditClose(rec, index)
    },
    onEditClosePieceElement: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        const rec = Object.assign({}, row.item)
        rec.keihiKingaku = Math.floor(parseFloat(this.getNullValue(rec.keihiTanka), 10) * parseFloat(this.getNullValue(rec.suryo), 10))
        this.onEditClose(rec, index)
      }
    },
    onEditCloseOdo: function (e, row) {
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        const rec = Object.assign({}, row.item)
        this.onEditClose(rec, index)
      }
    },
    onEditCloseSagyoJisshiBasho: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      rec.sagyoJisshiBasho = e.currentTarget._value === '' ? null : e.currentTarget._value
      this.onEditClose(rec, index)
    },
    onEditCloseKessaiCardNumber: function (e, row) {
      console.log(e, row)
      const index = this.rows.indexOf(row.item)
      const rec = Object.assign({}, row.item)
      rec.kessaiCardNumber = e.currentTarget._value === '' ? null : e.currentTarget._value
      this.onEditClose(rec, index)
    },
    onEditClose: function (rec, index) {
      // 変更フラグ判定（≠Clone値は変更有とみなす）
      if (this.isChanged(rec, this.cloneRows.rows[index])) {
        rec.editFlg = true
      } else {
        rec.editFlg = false
      }
      Object.assign(this.rows[index], rec)
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    isChanged: function (a, b) {
      if (a.hasseiYmd !== b.hasseiYmd ||
          a.hasseiHms !== b.hasseiHms ||
          a.torihikisakiId !== b.torihikisakiId ||
          a.mstSharyoId !== b.mstSharyoId ||
          a.nenryoShuruiKbn !== b.nenryoShuruiKbn ||
          a.suryo !== b.suryo ||
          a.keihiTanka !== b.keihiTanka ||
          a.odoMater !== b.odoMater ||
          a.sagyoJisshiBasho !== b.sagyoJisshiBasho ||
          a.kessaiCardNumber !== b.kessaiCardNumber) {
        return true
      } else {
        return false
      }
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return '0' }
      if (inputValue === undefined) { return '0' }
      if (inputValue === '') { return '0' }
      return this.removeComma(inputValue)
    },
    removeComma: function (num) {
      if (!num) { return '0' }

      if (window.isFinite(num) === true) {
        return num.toString()
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    // p = 1:ファイル取込の設定条件をクリアする
    // p = 2:検索条件をクリアする
    // p = 未指定:すべてクリア
    initBindVariables: function (p) {
      const self = this
      const d = new Date()
      let initConditions = Object.assign({}, self.conditions)
      initConditions = {
        importShiiresakiId: p === 2 ? self.conditions.importShiiresakiId : null,
        importFileKbn: p === 2 ? self.conditions.importFileKbn : '01',
        uploadFileName: p === 2 ? self.conditions.uploadFileName : '',
        uploadFileData: p === 2 ? self.conditions.uploadFileData : '',
        hasseiYmdStartString: p === 1 ? self.conditions.hasseiYmdStartString : date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        hasseiYmdEndString: p === 1 ? self.conditions.hasseiYmdEndString : date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        torihikisakiId: p === 1 ? self.conditions.torihikisakiId : null,
        sharyoShozokuEigyoshoId: p === 1 ? self.conditions.sharyoShozokuEigyoshoId : self.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(self.currentKaishaCode, self.eigyoshoList, 'eigyoshoCd', self.usersEigyoshoCd, filter.dateFormatter(d)).id : null,
        shashuSbt: p === 1 ? self.conditions.shashuSbt : null,
        mstSharyoId: p === 1 ? self.conditions.mstSharyoId : null,
        nenryoShuruiKbn: p === 1 ? self.conditions.nenryoShuruiKbn : null
      }
      self.conditions = Object.assign({}, initConditions)
      self.searchText = ''
      self.selected = []
      self.rows = []
      self.target = []
      self.torikomiConditonsRequired = true
      self.tableRowRequired = true
      self.headerMode = 1
    },
    // 色かえる
    itemRowBackground (item) {
      return item.errMessage ? 'cellBackgroundColorRed' : 'cellBackgroundColorWhite'
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    onDummyFunction: function () {
      return null
    }
  }
}
